import { render, staticRenderFns } from "./ESDetailTransp.vue?vue&type=template&id=b2a6f592&"
import script from "./ESDetailTransp.vue?vue&type=script&lang=js&"
export * from "./ESDetailTransp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports